import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=02079a8e&"
import script from "./attention.vue?vue&type=script&lang=js&"
export * from "./attention.vue?vue&type=script&lang=js&"
import style0 from "./attention.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports